/**
 * A labelled select for the overview filter bands, with the "All" option
 * built in. Shared so the jobs and reports filter rows sit on the same
 * baseline and wrap identically.
 */
export function FilterSelect({
  label,
  value,
  onChange,
  options,
  allLabel = 'All',
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: [string, string][];
  /** Wording for the empty option — "All statuses" reads better than "All". */
  allLabel?: string;
}) {
  return (
    <label>
      <span>{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{allLabel}</option>
        {options.map(([id, name]) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </select>
    </label>
  );
}
